export default __webpack_public_path__ + "static/media/select-area.e67bc1c9.svg";